<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      @destinatarios="destinatarios($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>

    <!-- Modal Destinatarios -->
    <div
      class="modal fade"
      id="modal_destinatarios"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        :class="`modal-dialog modal-dialog-centered modal-md`"
        role="document"
        style="width: 80%"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              DESTINATARIOS DE CORREO DEL REPORTE "{{
                `${item_actual ? item_actual.nombre : ""}`
              }}"
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="form-control-label">Destinatarios</label>
              <v-select
                class=""
                :reduce="(option) => option.id"
                v-model="destinatarios_ids"
                :options="destinatarios_correos"
                label="correo"
                multiple
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    No se Encontraron Resultados Para <em>{{ search }}</em
                    >.
                  </template>
                  <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                </template>
              </v-select>
            </div>

            <!-- <pre>{{destinatarios_ids}}</pre> -->
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <button
              type="button"
              @click="guardar_destinatarios"
              :class="`btn btn-primary`"
            >
              GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Destinatarios -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "ID",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "id",
      },
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombre",
      },
      {
        key: "nombre_archivo",
        label: "Nombre Archivo Adjunto",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombre_archivo",
      },
      {
        key: "frecuencia",
        label: "Frecuencia de Envio",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "frecuencia_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "hora_generacion",
        label: "Hora",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "hora_generacion",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Destinatarios",
        clase: "btn-primary",
        evento: "destinatarios",
        icono: "fa fa-users",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "nombre",
        valor: "",
        label: "Nombre (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "nombre_archivo",
        valor: "",
        label: "Nombre Archivo Adjunto (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select",
        key: "frecuencia",
        valor: "",
        label: "Frecuencia de Envío (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 4,
        tipo: "texto",
        key: "hora_generacion",
        valor: "",
        label: "Hora (*)",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Informe Automático de Correo",
      ancho: "lg",
      ruta: "/reportes_correos",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Informes de Correo",
      titulo_boton: "Crear Informe de Correo",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    frecuencias_reportes: [],
    item_actual: null,
    destinatarios_correos: [],
    destinatarios_ids: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }

    this.cargar_destinatarios();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_destinatarios() {
      await this.axios
        .get(`${this.api}/destinatarios?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.destinatarios_correos = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_frecuencias_reportes();
    },

    async cargar_frecuencias_reportes() {
      await this.axios
        .get(`${this.api}/frecuencia_reportes`, this.cabeceras_json)
        .then((res) => {
          this.frecuencias_reportes = res.data.data;
          this.columnas[3].opciones = this.frecuencias_reportes;
          this.inputs[2].opciones = this.frecuencias_reportes;
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/reportes_correos${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/reportes_correos${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/reportes_correos`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });

      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/reportes_correos/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },

    destinatarios(evento) {
      //console.log('destinatarios',evento);
      this.item_actual = evento.item;
      this.destinatarios_ids = this.item_actual.destinatarios_ids;
      $("#modal_destinatarios").modal({ show: true });
    },

    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    async guardar_destinatarios() {
      let body = {
        destinatarios_ids: this.destinatarios_ids,
      };
      await this.axios
        .post(
          `${this.api}/reportes_correos/${this.item_actual.id}/guardar_destinatarios`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log('respuesta',res.data);
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>